import React, { Component, Fragment } from "react";
import "./Toast.css";
class Toast extends Component {
    constructor(props) {
        super(props);
        this.addToast = this.addToast.bind(this);
    }
    lastToastID = 0;
    expireDelay = 5;
    state = {
        toasts: [],
    };
    componentDidMount() {
        this.props.setToastHook(this.addToast);
        setInterval(() => {
            let { toasts } = this.state;
            for (let i = 0; i < toasts.length; i++) {
                let now = new Date().getTime() / 1000;
                if (toasts[i].expire <= now) {
                    toasts.splice(i, 1);
                    i--;
                }
            }
            this.setState(toasts);
        }, 1000);
    }

    addToast(header, message, color, expire = this.expireDelay) {
        let { toasts } = this.state;
        let now = new Date().getTime() / 1000;

        toasts.push({
            header,
            message,
            color,
            id: ++this.lastToastID,
            expire: now + expire,
        });
        this.setState(toasts);
    }

    closeToast(toast) {
        let { toasts } = this.state;
        toasts.splice(
            toasts.findIndex((t) => {
                return t.id == toast.id;
            }),
            1
        );
        this.setState(toasts);
    }
    render() {
        let { toasts } = this.state;
        return (
            <Fragment>
                {toasts.length > 0 && (
                    <div className="ToastsContainer">
                        {toasts.map((t) => {
                            return (
                                <div className={"Toast " + t.color} key={t.id}>
                                    <i
                                        className="ri-close-circle-line"
                                        onClick={(e) => this.closeToast(t)}
                                    ></i>
                                    <h4 className="header">{t.header}</h4>
                                    <div className="message">{t.message}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </Fragment>
        );
    }
}

export default Toast;
